import colors from 'src/theme/base/colors';
import boxShadows from 'src/theme/base/boxShadows';
import borders from 'src/theme/base/borders';

const { white } = colors;
const { xxl } = boxShadows;
const { borderRadius } = borders;

const tableContainer = {
  styleOverrides: {
    root: {
      backgroundColor: white.main,
      boxShadow: xxl,
      borderRadius: borderRadius.xl,
    },
  },
};

export default tableContainer;
